var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"superlock-view"},[_c('div',{staticClass:"menuSettingsWrapper"},[_c('el-table',{staticClass:"growTable",attrs:{"data":_vm.superlockList}},[_c('el-table-column',{attrs:{"prop":"label","label":_vm.thirdLevelLabel}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }